module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_5_3.f7628869.png";